// Company branding configuration
// These values are populated from environment variables at build time

export const companyConfig = {
  name: process.env.NEXT_PUBLIC_COMPANY_NAME || '',
  domain: process.env.NEXT_PUBLIC_COMPANY_DOMAIN || '',
  dashboardUrl: process.env.NEXT_PUBLIC_DASHBOARD_URL || '',
};
